export default "__VITE_ASSET__T65gV9cI__"